/** Visual variant for **`qz-btn`** shared styles. */
export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: "qz-btn qz-btn--primary",
  secondary: "qz-btn qz-btn--secondary",
  ghost: "qz-btn qz-btn--ghost",
  danger: "qz-btn qz-btn--danger",
};

/**
 * Builds an action {@link HTMLButtonElement} using shared **`qz-*`** styles.
 *
 * @param label - Visible label (normally resolved via **`Translate`**).
 * @param options - **`variant`**, disabled flag, and **`HTMLButtonElement.type`** override.
 * @returns Connected-ready native button with **`qz-btn`** classes applied.
 */
export function createButton(
  label: string,
  options?: Readonly<{
    disabled?: boolean;
    type?: "button" | "submit";
    variant?: ButtonVariant;
  }>,
): HTMLButtonElement {
  const btn = document.createElement("button");
  btn.type = options?.type ?? "button";
  btn.disabled = Boolean(options?.disabled);
  btn.textContent = label;
  const variant = options?.variant ?? "primary";
  btn.className = VARIANT_CLASS[variant];
  return btn;
}
